import { render } from "./RegistCode.vue?vue&type=template&id=3ca4af40&scoped=true"
import script from "./RegistCode.vue?vue&type=script&lang=js"
export * from "./RegistCode.vue?vue&type=script&lang=js"

import "./RegistCode.vue?vue&type=style&index=0&id=3ca4af40&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/xxiwant/lovestory/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca4af40"]])

export default __exports__